// This component mirrors example from GraphiQL documentation.
import React from "react";
//graphiql package
import GraphiQL from "graphiql";

//components
import ShareQueryButton from "./ShareQueryButton";
import ViewSchemaButton from "./ViewSchemaButton";

import axios from "axios";

// Styling
import "graphiql/graphiql.css";
import "./Module.css";

class GraphiQLComponent extends React.Component {
  constructor(props) {
    super(props);
    this.shareQueryInputRef = React.createRef();
    // this.wrapperRef = React.createRef();
    this.state = {
      fetcher: this.props.fetcher,
      query: this.props.getQuery(),
      variables: "",
      response: "",
      schema: undefined,
      operationName: null,
      storage: null,
      defaultQuery: null,
      onEditQuery: null,
      onEditVariables: null,
      onEditOperationName: null,
      getDefaultFieldNames: null,
      shareQueryToggle: false,
      shareQueryString: "",
      isQueryCopiedToClipBoard: false,
      isUrlPrettified: false,
      isLoadingBitlyLink: false,
    };

    this.getShareText = this.getShareText.bind(this);
    this.copyToClipBoard = this.copyToClipBoard.bind(this);
    this.toggleIsUrlPrettified = this.toggleIsUrlPrettified.bind(this);
    this.getBitlyLink = this.getBitlyLink.bind(this);
    this.loadBitlyLink = this.loadBitlyLink.bind(this);
  }

  // this function will copy the encoded query to clipboard so the user can
  // share the link which will take to the Query module with the query already
  // types and formatted
  copyToClipBoard() {
    this.shareQueryInputRef.current.select();
    this.shareQueryInputRef.current.setSelectionRange(0, 99999);

    document.execCommand("copy");

    localStorage.setItem("hasSharedQuery", JSON.stringify(true));

    this.setState({
      ...this.state,
      isQueryCopiedToClipBoard: true,
    });

    setTimeout(() => {
      this.setState({
        ...this.state,
        shareQueryToggle: false,
        isQueryCopiedToClipBoard: false,
        isUrlPrettified: false,
      });
    }, 5000);

    clearTimeout();
  }

  loadBitlyLink() {
    this.setState({ ...this.state, isLoadingBitlyLink: true });
  }

  toggleIsUrlPrettified() {
    this.setState({
      ...this.state,
      isUrlPrettified: !this.state.isUrlPrettified,
      shareQueryString: !this.state.isUrlPrettified
        ? this.state.shareQueryString + "&prettify=1"
        : this.state.shareQueryString.slice(0, -11),
    });
  }

  async getBitlyLink(shareQueryString) {
    try {
      const bitlyLink = await axios({
        method: "post",
        url: "https://us-central1-semi-production.cloudfunctions.net/create-bitly",
        data: {
          url: shareQueryString,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      return bitlyLink.data;
    } catch (error) {
      return null;
    }
  }

  // when suer clicks the share query button, this function will
  // get the query from the editor
  async getShareText() {
    const editor = this.graphiql.getQueryEditor();
    const query = editor && editor.getValue();
    const encodedQuery = encodeURIComponent(query);

    this.loadBitlyLink();

    let shareQueryString = `${window.origin}/console/query#weaviate_uri=${
      JSON.parse(localStorage.getItem("connectToWeaviateURI")) ||
      "https://demo.dataset.playground.semi.technology"
    }&graphql_query=${encodedQuery}`;

    const result = await this.getBitlyLink(shareQueryString);

    if (result !== null) {
      shareQueryString = result;
    }

    this.setState({
      ...this.state,
      shareQueryToggle: true,
      isLoadingBitlyLink: false,
      shareQueryString: shareQueryString,
    });
  }

  render() {
    return (
      <GraphiQL
        headerEditorEnabled={false}
        editorTheme='solarized light'
        ref={(c) => {
          this.graphiql = c;
        }}
        {...this.state}
        toolbar={{
          additionalContent: (
            <React.Fragment>
              <ViewSchemaButton />
              <ShareQueryButton
                state={this.state}
                theme={this.props.state.theme}
                getShareText={this.getShareText}
                toggleIsUrlPrettified={this.toggleIsUrlPrettified}
                copyToClipBoard={this.copyToClipBoard}
                shareQueryInputRef={this.shareQueryInputRef}
              />
            </React.Fragment>
          ),
        }}
      >
        <GraphiQL.Logo>&nbsp;</GraphiQL.Logo>
      </GraphiQL>
    );
  }
}

export default GraphiQLComponent;
